import { render, staticRenderFns } from "./TableHeaderCellV2.vue?vue&type=template&id=a38c35e0&scoped=true&"
import script from "./TableHeaderCellV2.vue?vue&type=script&lang=js&"
export * from "./TableHeaderCellV2.vue?vue&type=script&lang=js&"
import style0 from "./TableHeaderCellV2.vue?vue&type=style&index=0&id=a38c35e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38c35e0",
  null
  
)

export default component.exports